export default __webpack_public_path__ + "static/media/logo.b6784d4a.png";